import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { sessionReducer } from "redux-react-session";
import appReducer from "./AppReducer";
import locationReducer from "./locationReducer";
import declaracionJuradaReducer from "./DeclaracionJuradaReducer";
import dataReducer from "./DataReducer";
import afiliadoReducer from "./AfiliadoReducer";
import boletaReducer from "./BoletaReducer";
import empresaReducer from "./EmpresaReducer";
import holidayReducer from "./HolidayReducer";
import fixedContributionReducer from "./FixedContributionReducer";
import userControlReducer from "./UserControlReducer";
import BIModuleReducer from "./BIModuleReducer";
import paymentMethodReducer from "./PaymentMethodReducer";
import salaryReducer from "./SalaryReducer";
import supportTicket from "./SupportTicketReducer";

const rootReducer = combineReducers({
	form: formReducer,
	app: appReducer,
	locations: locationReducer,
	declaracionJurada: declaracionJuradaReducer,
	holiday: holidayReducer,
	data: dataReducer,
	afiliado: afiliadoReducer,
	boleta: boletaReducer,
	empresa: empresaReducer,
	session: sessionReducer,
	fixedContribution: fixedContributionReducer,
	userControl: userControlReducer,
	biModule: BIModuleReducer,
	paymentMethod: paymentMethodReducer,
	salary: salaryReducer,
	supportTicket: supportTicket
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js